import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import {
    get_admin_juryBriefing_list_action, juryBriefing_insertUpdate_action
} from "../../../actions/adminModule_action/adminModule_action";
import { responseError, role_id, toastError, toastSuccess, user_id } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
import { Modal } from "react-bootstrap";
import moment from "moment";
import Footer from "../../../common_components/Footer";
import MobileHeader from "../../../common_components/mobileHeader";

class AdminJuryBriefing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isJuryModal: false,
            user_id: "",
            jury_id: "",
            jury_briefing_by: "",
            jury_briefing_date: "",
            Description: "",
            is_active: "",
            JuryBriefingData: [],
            filteredData: [],
            statusFillList: [],
            isAccordionExpanded: false,
            currentPage: 1, award_event_jury_briefing_id: '', jury_briefing_byErr: "", jury_briefing_dateErr: ""
        };
        this.navigateJuryBriefing = this.navigateJuryBriefing.bind(this);
        this.getJuryBriefingData = this.getJuryBriefingData.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.updateItem = this.updateItem.bind(this);
    }
    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }
        this.setState({
            user_id: user_id
        });
        this.getJuryBriefingData();
    }

    getJuryBriefingData() {
        const { } = this.state;
        this.setState({ isLoading: true });
        this.props
            .get_admin_juryBriefing_list_action()
            .then((data) => {
                if (data.error !== 1) {
                    this.setState({
                        JuryBriefingData: data.data,
                        isLoading: false,
                        currentpage: 1,
                    });
                } else {
                    this.setState({ isLoading: false });
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    navigateRoleAdd() {
        this.props.navigate("/roleAU", {
            state: { jury_id: 0 },
        });
    }
    navigateJuryBriefing(jury_id) {
        this.props.navigate(`/roleAU`, {
            state: { jury_id: jury_id },
        });
    }

    clearFilters() {
        const { Name, Status } = this.state;
        this.setState({
            Name: "",
            Status: "",
        });
        setTimeout(() => {
            this.getJuryBriefingData();
        }, 100);
    }
    updateItem(item) {
        this.setState({ currentPage: item });
    }
    openModalJury(jury_id, award_event_jury_briefing_id, jury_briefing_by, jury_briefing_date) {
        this.setState({
            jury_id: jury_id,
            award_event_jury_briefing_id: award_event_jury_briefing_id,
            jury_briefing_by: jury_briefing_by,
            jury_briefing_date: jury_briefing_date ? moment(jury_briefing_date).format("YYYY-MM-DD") : '',
            isJuryModal: true
        });
    }

    closeModalJury() {
        this.setState({ jury_id: '', award_event_jury_briefing_id: '', jury_briefing_by: '', jury_briefing_date: '', isJuryModal: false })
    }
    submitJuryBriefing() {
        const { jury_id, award_event_jury_briefing_id, jury_briefing_by, jury_briefing_date } = this.state
        if (jury_briefing_by == '') { toastError('Kindly Provide Briefing By Name') }
        else if (jury_briefing_date == '') { toastError('Kindly select Briefing Date') }
        else {
            this.setState({ isLoading: true });
            this.props.juryBriefing_insertUpdate_action(jury_id, award_event_jury_briefing_id, jury_briefing_by, jury_briefing_date)
                .then((data) => {
                    this.setState({ isLoading: false })
                    if (data.error !== 1) {
                        this.setState({ isJuryModal: false }, () => toastSuccess('Briefing Data Submitted Successfully'))
                        this.getJuryBriefingData();
                    } else {
                        responseError(data);
                    }
                }).catch((e) => {
                    console.log(e);
                })
        }
    }
    juryBriefingRecord(JuryBriefingData) {
        // const { userList } =this.state
        return (
            <table class="table table-bordered" id="dashboard-table">
                <thead>
                    <tr>
                        <th style={{ width: '25%' }}>Name of the Jury</th>
                        <th style={{ width: '10%' }}>Specialization</th>
                        <th style={{ width: '15%' }}>Briefing By</th>
                        <th className="text-center" style={{ width: '8%' }}>Briefing Date</th>
                        <th style={{ width: '3%' }} className="text-right">

                        </th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {JuryBriefingData?.length > 0 ? (
                        JuryBriefingData.map((data) => (
                            <tr>
                                <td>{data.jury_name}</td>
                                <td>{data.specialization}</td>
                                <td>{data.jury_briefing_by != '' ? data.jury_briefing_by : 'PENDING'}</td>
                                <td className="text-center">{data.jury_briefing_date != null ? moment(data.jury_briefing_date).format("DD-MM-YYYY") : "PENDING"}</td>
                                <td className="text-center">
                                    {data.award_event_jury_briefing_id != 0 && (
                                        <a
                                            href="javascript:void(0);"
                                            title="Edit"
                                            className="btn btn-sm"
                                            onClick={() => this.openModalJury(data.jury_id, data.award_event_jury_briefing_id, data.jury_briefing_by, data.jury_briefing_date)}
                                        >
                                            <i className="fa fa-pencil-square-o text-primary"></i>
                                        </a>
                                    )}
                                    {data.award_event_jury_briefing_id == 0 && (
                                        <a
                                            title="Add"
                                            className="btn btn-sm add_record"
                                            onClick={() => this.openModalJury(data.jury_id, data.award_event_jury_briefing_id, data.jury_briefing_by, data.jury_briefing_date)}
                                        >
                                            <i className="fa fa-plus-square-o text-info" style={{ fontSize: '17px' }}></i>
                                        </a>
                                    )}
                                </td>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={5} className="text-center">
                                No records found
                            </td>
                        </tr>

                    )}
                </tbody>
            </table>
        );
    }
    render() {
        const {
            isLoading, isJuryModal,
            JuryBriefingData,
            currentPage,
            isAccordionExpanded,
            Name,
            is_active,
            jury_id, jury_briefing_by, jury_briefing_byErr, jury_briefing_date, jury_briefing_dateErr
        } = this.state;
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = JuryBriefingData?.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(JuryBriefingData?.length / recordsPerPage);

        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>
                    <main id="main">

                        <div className="website-view">
                            <Header data={[8]} />
                        </div>
                        <div className="mobile-view">
                            <MobileHeader data={[8]} />
                        </div>
                        {/* <Header data={[20]} /> */}
                        <section class='header_margin_top'>
                            <div className="container-fluid">
                                <div className="page-header">
                                    <h2 className="mb-3 dashboard-tit  py-0 blog-name blog-name-1">Jury Briefing</h2>
                                </div>
                                <div className="custom_table">
                                    <div className="hack1">
                                        <div className="hack2">
                                            {this.juryBriefingRecord(currentRecords)}
                                            {JuryBriefingData.length > 0 ? (
                                                <Pagination
                                                    nPages={nPages}
                                                    currentPage={currentPage}
                                                    setCurrentPage={this.updateItem}
                                                />
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                        <Modal show={isJuryModal}
                                            size="lg"
                                        >
                                            <div class="page-header page-header px-3 p-1 rounded-0" style={{ backgroundColor: '#eeeeee', }}>
                                                <h4 class="page-title">Add/Edit Briefing</h4>
                                                <div className="Service_display">
                                                    {/* <h1
                                                                className="Services_Active_or_Not"
                                                                style={{
                                                                    fontSize: "25px",
                                                                    fontWeight: "800",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => this.closeModalJury()}
                                                            >
                                                                X
                                                            </h1> */}
                                                    <span onClick={() => this.closeModalJury()} style={{
                                                        fontSize: "25px",
                                                        cursor: "pointer",
                                                    }}>&times;</span>
                                                </div>
                                            </div>
                                            <Modal.Body>


                                                <div className="company_info pt-4">
                                                    <div className="outside_input_field ">
                                                        <div class="row">
                                                            <div class="col-md-8">
                                                                <div class="form-group">
                                                                    <div class="position-relative">
                                                                        <input
                                                                            value={jury_briefing_by}
                                                                            type="text"
                                                                            class="outside"
                                                                            required
                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                            maxLength={30}
                                                                            onChange={(e) =>
                                                                                this.setState({ jury_briefing_by: e.target.value })
                                                                            }
                                                                        />
                                                                        {
                                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                                {jury_briefing_byErr}
                                                                            </span>
                                                                        }
                                                                        <span class="floating-label-outside">
                                                                            Briefing By <span class="mendatory_class">*</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <div class="form-group">
                                                                    <div class="position-relative">
                                                                        <input
                                                                            value={this.state.jury_briefing_date}
                                                                            type="date"
                                                                            className="outside"
                                                                            required
                                                                            onChange={(e) => this.setState({ jury_briefing_date: e.target.value })}
                                                                        />

                                                                        {
                                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                                {jury_briefing_dateErr}
                                                                            </span>
                                                                        }
                                                                        <span class="floating-label-outside">
                                                                            Briefing Date <span class="mendatory_class">*</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />

                                                </div>
                                            </Modal.Body>
                                            <div class="model-footer text-right p-2 px-3">
                                                <a
                                                    class="btn btn-outline-primary btn-sm create_btn add_additional_days_btn mr-2"
                                                    style={{ width: "max-content" }}
                                                    onClick={() => this.submitJuryBriefing()}
                                                >
                                                    Submit
                                                </a>
                                                <a
                                                    class="btn btn-outline-secondary btn-sm create_btn add_additional_days_btn "
                                                    style={{ width: "max-content" }}
                                                    onClick={() => this.closeModalJury()}
                                                >
                                                    Close
                                                </a>
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>

                    <Footer />
                    <ToastContainer />
                </>
            </>
        );
    }
}
export default withRouter(
    connect(null, { get_admin_juryBriefing_list_action, juryBriefing_insertUpdate_action })(AdminJuryBriefing)
);
